import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { TellentAppsActions, TellentAppsSelectors } from '@core/tellent-data';
import { SeatKind, TellentSubscriptionStatus } from '@core/tellent-types';

@Injectable({
  providedIn: 'root',
})
export class TellentAppsDataFacade {
  private readonly store = inject(Store);

  public entities = this.store.selectSignal(TellentAppsSelectors.entities());

  public rolesSelectOptions(kind: SeatKind) {
    return this.store.selectSignal(TellentAppsSelectors.selectRolesSelectOptions(kind));
  }

  public appBySeatKind(kind: SeatKind) {
    return this.store.selectSignal(TellentAppsSelectors.selectAppBySeatKind(kind));
  }

  public defaultRoleBySeatKind(kind: SeatKind) {
    return this.store.selectSignal(TellentAppsSelectors.selectDefaultRoleBySeatKind(kind));
  }

  public hasAnySubscriptionStatus(kind: SeatKind, statuses: TellentSubscriptionStatus[]) {
    return this.store.selectSignal(
      TellentAppsSelectors.selectHasAnySubscriptionStatus({ seatKind: kind, statuses }),
    );
  }

  public fetchCollection() {
    this.store.dispatch(TellentAppsActions.fetchCollection());
  }
}
